export default {"src":"/_next/static/media/character-d.mono.f0066617.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};